// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3nv6Q","label":"Radio_label__TOJhu","checkMark":"Radio_checkMark__OlqMW","disabled":"Radio_disabled__dv85P"};